/** Factory for the village family (EntityManager.spawnMob falls back to this). */

import type { MobType } from '../../game/types';
import type { Mob } from '../mob';
import { IronGolem } from './golem';
import { Pillager, Vindicator, ZombieVillager } from './illagers';
import { Villager } from './villager';

export const VILLAGE_MOB_TYPES: readonly MobType[] = ['villager', 'iron_golem', 'pillager', 'vindicator', 'zombie_villager'];

export function createVillageMob(type: MobType, id: number, x: number, y: number, z: number, rnd: () => number): Mob | null {
  switch (type) {
    case 'villager': return new Villager(id, x, y, z, rnd);
    case 'iron_golem': return new IronGolem(id, x, y, z, rnd);
    case 'pillager': return new Pillager(id, x, y, z, rnd);
    case 'vindicator': return new Vindicator(id, x, y, z, rnd);
    case 'zombie_villager': return new ZombieVillager(id, x, y, z, rnd);
    default: return null;
  }
}

export { IronGolem, Pillager, Vindicator, Villager, ZombieVillager };
